import { askJimIdeaLoader, askJimPortrait, askJimThinkingLoader, bubbleAssets } from "./assets";
import { appContent } from "./content";
import type { BubbleHeight, BubbleWidth } from "./types";
import { escapeHtml } from "./utils";

type SetupCredential = {
  username: string;
  temporaryPassword: string;
};

type CredentialMarkupOptions = {
  heading: string;
  note: string;
};

export function loaderMarkup(kind: "thinking" | "success", label: string): string {
  const src = kind === "thinking" ? askJimThinkingLoader : askJimIdeaLoader;
  return `
    <div class="jim-state ${kind}">
      <img src="${src}" alt="" aria-hidden="true" />
      <span>${escapeHtml(label)}</span>
    </div>
  `;
}

function chooseBubbleVariant(message: string): { width: BubbleWidth; height: BubbleHeight } {
  const length = message.length;
  if (length <= 34) return { width: "compact", height: "short" };
  if (length <= 76) return { width: "standard", height: "short" };
  if (length <= 125) return { width: "wide", height: "medium" };
  return { width: "wide", height: "tall" };
}

export function jimBubbleMarkup(message: string, tone: "neutral" | "warning" | "success" = "neutral"): string {
  const variant = chooseBubbleVariant(message);
  const src = bubbleAssets[variant.width][variant.height];
  return `
    <div class="jim-callout jim-callout--${variant.width} jim-callout--${variant.height}" role="status">
      <div class="jim-bubble jim-bubble--${variant.width} jim-bubble--${variant.height} jim-bubble--${tone}">
        <img src="${src}" alt="" aria-hidden="true" />
        <p>${escapeHtml(message)}</p>
      </div>
      <img class="jim-head" src="${askJimPortrait}" alt="" aria-hidden="true" />
    </div>
  `;
}

export function credentialMarkup(credential: SetupCredential | null, options: CredentialMarkupOptions): string {
  if (!credential) return "";
  return `
    <div class="credential-box" role="status">
      ${loaderMarkup("success", options.heading)}
      <div class="credential-row">
        <span>${appContent.credentials.username}</span>
        <strong>${escapeHtml(credential.username)}</strong>
        <button type="button" class="ghost copyButton" data-copy="${escapeHtml(credential.username)}">${appContent.credentials.copy}</button>
      </div>
      <div class="credential-row">
        <span>${appContent.credentials.temporaryPassword}</span>
        <strong>${escapeHtml(credential.temporaryPassword)}</strong>
        <button type="button" class="ghost copyButton" data-copy="${escapeHtml(credential.temporaryPassword)}">${appContent.credentials.copy}</button>
      </div>
      <p class="muted">${options.note}</p>
    </div>
  `;
}
